export const transformations = [
    {
        id: "range-rover-ceramic",
        vehicle: "Range Rover",
        service: "Ceramic Coating",
        category: "protection",
        image: "/assets/transformations/range-rover-ceramic.webp",
        alt: "Real Revautoz work — Range Rover bonnet without ceramic versus with ceramic coating, deep reflective gloss after application",
        caption: "From dull and weathered to a deep, reflective finish.",
        sub: "Enhanced gloss, depth and surface protection designed to keep the finish looking refined.",
        reaction: "THE GLOSS TRANSFORMATION IS INCREDIBLE.",
        customerComment: "",
        rating: null,
    },
    {
        id: "mercedes-interior",
        vehicle: "Mercedes-Benz",
        service: "Interior Deep Cleaning",
        category: "detailing",
        image: "/assets/transformations/mercedes-interior-cleaning.webp",
        alt: "Real Revautoz work — Mercedes-Benz cabin before and after interior deep cleaning, seats and carpets restored",
        caption: "From heavily used interiors to a refreshed, clean and premium cabin.",
        sub: "",
        reaction: "THE INTERIOR FEELS COMPLETELY DIFFERENT.",
        customerComment: "",
        rating: null,
    },
    {
        id: "hyundai-ppf",
        vehicle: "Hyundai",
        service: "Paint Protection Film",
        category: "protection",
        image: "/assets/transformations/hyundai-ppf.webp",
        alt: "Real Revautoz work — Hyundai bonnet without PPF versus with paint protection film, clean high-gloss finish",
        caption: "The finish is the difference.",
        sub: "Paint protection designed to preserve the finish while maintaining a clean, high-gloss appearance.",
        reaction: "THE DIFFERENCE IS UNMISSABLE.",
        customerComment: "",
        rating: null,
    },
    {
        id: "evoque-polish",
        vehicle: "Range Rover Evoque",
        service: "Paint Polish",
        category: "paint",
        image: "/assets/transformations/range-rover-evoque-polish.webp",
        alt: "Real Revautoz work — Range Rover Evoque before polish and after polish, paint depth and gloss restored",
        caption: "From faded and tired to deep, glossy and refined.",
        sub: "",
        reaction: "THE PAINT LOOKS LIKE NEW AGAIN.",
        customerComment: "",
        rating: null,
    },
    {
        id: "fortuner-legender",
        vehicle: "Toyota Fortuner",
        service: "Customization",
        category: "custom",
        image: "/assets/transformations/fortuner-legender.webp",
        alt: "Real Revautoz work — Toyota Fortuner old model restyled to the new Legender look, complete front-end transformation",
        caption: "The same foundation. A completely new presence.",
        sub: "Full restyling — Revautoz is a transformation destination, not only a detailing studio.",
        reaction: "IT LOOKS LIKE A DIFFERENT CAR.",
        customerComment: "",
        rating: null,
    },
    {
        id: "polo-paint-restoration",
        vehicle: "Volkswagen Polo",
        service: "Paint Restoration",
        category: "paint",
        image: "/assets/transformations/polo-paint-restoration.webp",
        alt: "Real Revautoz work — Volkswagen Polo with sun-faded patchy paint before, even deep factory gloss after restoration",
        caption: "Sun-faded, patchy paint brought back to an even, deep factory gloss.",
        sub: "",
        reaction: "FROM FADED TO FACTORY-FRESH.",
        customerComment: "",
        rating: null,
    },
    {
        id: "seltos-paint-correction",
        vehicle: "Kia Seltos",
        service: "Paint Correction",
        category: "paint",
        image: "/assets/transformations/seltos-paint-correction.webp",
        alt: "Real Revautoz work — Kia Seltos fender covered in deep scratches before, clean deep gloss after paint correction",
        caption: "Deep scratches, swirls and dull paint refined into a cleaner, deeper finish.",
        sub: "",
        reaction: "SCRATCHES GONE. GLOSS RESTORED.",
        customerComment: "",
        rating: null,
    },
    {
        id: "headlight-restoration",
        vehicle: "Hatchback",
        service: "Headlight Restoration",
        category: "detailing",
        image: "/assets/transformations/headlight-restoration.webp",
        alt: "Real Revautoz work — cloudy yellowed headlight before, crystal-clear lens after restoration",
        caption: "Cloudy, yellowed lenses restored to crystal-clear clarity.",
        sub: "",
        reaction: "THE LEVEL OF DETAIL IS INSANE.",
        customerComment: "",
        rating: null,
    },
    {
        id: "jimny-custom-interior",
        vehicle: "Suzuki Jimny",
        service: "Custom Interior",
        category: "custom",
        image: "/assets/transformations/jimny-custom-interior.webp",
        alt: "Real Revautoz work — Suzuki Jimny factory fabric cabin before, bespoke tan diamond-stitched leather interior after",
        caption: "Factory interior transformed into a bespoke premium cabin.",
        sub: "",
        reaction: "THE CABIN IS UNRECOGNISABLE.",
        customerComment: "",
        rating: null,
    },
];

export const transformationFilters = [
    { id: "all", label: "All" },
    { id: "detailing", label: "Detailing" },
    { id: "paint", label: "Paint" },
    { id: "protection", label: "Protection" },
    { id: "custom", label: "Custom" },
];
